import { RootState } from "@app/store";
// import { getSetting } from "@app/utils/project";
import { memo } from "react";
import { useSelector } from "react-redux";
import {
  StyledLogoImage,
  StyledHeader,
  StyledSpan
} from "./mainHeader.styles";

type MainHeaderProps = {};

export const Header = ({}: MainHeaderProps) => {

  const name = useSelector((state: RootState) => state.customer.name);
  const logoTypeUrl = useSelector((state: RootState) => state.setting.logoTypeUrl);

  return (
    <StyledHeader>
      <StyledLogoImage src={logoTypeUrl} alt="Logo" />
      {name && <StyledSpan> {name} </StyledSpan>}
    </StyledHeader>
  );
};

export const MemoHeader = memo(Header)
